import { useTranslation } from 'react-i18next';
import type { IDataModelAttributesProps } from './IDataModelAttributesProps';

/**
 * «Атрибути · Сутність» (прототип v4 mdSel): таблиця — ключ (моноширинний), підпис, тип («посилання → Справи»), обов'язковість («так»),
 * варіанти або «системне поле»; для основної сутності — «Статуси · життєвий цикл основного запису» пігулками з номером і крапкою.
 */
export function DataModelAttributes({ entity, statusLabel, statusColor }: IDataModelAttributesProps) {
  const { t } = useTranslation();
  const { rt } = entity;
  return (
    <section className="dm-section">
      <div className="dm-label">
        <span className="dm-label__title">{t('modDesign.model.attributes', { name: entity.name })}</span>
        <span className="dm-label__sub">{t(`modDesign.model.kinds.${entity.kind}`)}</span>
      </div>
      <div className="dm-card dm-card--scroll">
        <div className="dm-attr dm-attr--head">
          <span>{t('modDesign.model.cols.key')}</span><span>{t('modDesign.model.cols.label')}</span><span>{t('modDesign.model.cols.type')}</span>
          <span>{t('modDesign.model.cols.required')}</span><span>{t('modDesign.model.cols.options')}</span>
        </div>
        {entity.attrs.map((a) => (
          <div key={a.key} className="dm-attr">
            <span className="dm-attr__key">{a.key}</span><span className="dm-attr__label">{a.label}</span>
            <span className="dm-attr__type">{a.type}</span><span className="dm-attr__req">{a.required ? t('modDesign.model.yes') : ''}</span>
            <span className="dm-attr__opts" title={a.options}>{a.options}</span>
          </div>
        ))}
      </div>
      {entity.kind === 'main' && rt && rt.statuses.list.length > 0 && (
        <>
          <div className="dm-label"><span className="dm-label__title">{t('modDesign.model.statuses')}</span><span className="dm-label__sub">{t('modDesign.model.statusesSub')}</span></div>
          <div className="dm-statuses">
            {rt.statuses.list.map((s, i) => (
              <span key={s.value} className="dm-status"><span className="dm-status__n">{i + 1}</span><span className="dm-dot" style={{ background: statusColor(s.value) }} />{statusLabel(s.value)}</span>
            ))}
          </div>
        </>
      )}
    </section>
  );
}
